<template>
  <div v-if="api_data.Farmer" class="card rounded-0 card-custom gutter-b">
    <div class="card-header border-0 pt-5">
      <div class="card-title">
        <div class="card-label">
          <div class="font-weight-bolder">
            {{ $t('Cultivation') }}
          </div>
          <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t('Information') }}</span>
        </div>
      </div>
    </div>
    <div class="card-body pt-2">
      <div class="card-body">
        <div class="row"
             v-if="api_data.Farmer.cultivation_monsoon_forest_land_acre || api_data.Farmer.cultivation_monsoon_forest_land_guntha || api_data.Farmer.cultivation_monsoon_forest_land"
        >
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_monsoon_forest_land_acre"
                    v-bind:label="'Acre'"
                ></label-text>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_monsoon_forest_land_guntha"
                    v-bind:label="'Guntha'"
                ></label-text>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'cultivation_monsoon_forest_land'"
                v-bind:head_title="'Monsoon Forest Land'"
                v-bind:operation_mode="'read'"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_monsoon_forest_land_details'"
            v-bind:head_title="'Monsoon Forest Land Details'"
            v-bind:default_autocomplete_list="cultivation_forest_land_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <div class="row"
             v-if="api_data.Farmer.cultivation_winter_forest_land_acre || api_data.Farmer.cultivation_winter_forest_land_guntha || api_data.Farmer.cultivation_winter_forest_land"
        >
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_winter_forest_land_acre"
                    v-bind:label="'Acre'"
                ></label-text>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_winter_forest_land_guntha"
                    v-bind:label="'Guntha'"
                ></label-text>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'cultivation_winter_forest_land'"
                v-bind:head_title="'Winter Forest Land'"
                v-bind:operation_mode="'read'"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <div class="row"
             v-if="api_data.Farmer.cultivation_summer_forest_land_acre || api_data.Farmer.cultivation_summer_forest_land_guntha || api_data.Farmer.cultivation_summer_forest_land"
        >
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_summer_forest_land_acre"
                    v-bind:label="'Acre'"
                ></label-text>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_summer_forest_land_guntha"
                    v-bind:label="'Guntha'"
                ></label-text>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'cultivation_summer_forest_land'"
                v-bind:head_title="'Summer Forest Land'"
                v-bind:operation_mode="'read'"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_summer_forest_land_details'"
            v-bind:head_title="'Summer Forest Land Details'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_winter_forest_land_details'"
            v-bind:head_title="'Winter Forest Land Details'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <div class="row"
             v-if="api_data.Farmer.cultivation_revenue_forest_land_acre || api_data.Farmer.cultivation_revenue_forest_land_guntha || api_data.Farmer.cultivation_revenue_forest_land"
        >
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_revenue_forest_land_acre"
                    v-bind:label="'Acre'"
                ></label-text>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_revenue_forest_land_guntha"
                    v-bind:label="'Guntha'"
                ></label-text>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'cultivation_revenue_forest_land'"
                v-bind:head_title="'Revenue Forest Land'"
                v-bind:operation_mode="'read'"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_revenue_forest_land_details'"
            v-bind:head_title="'Revenue Forest Land Details'"
            v-bind:default_autocomplete_list="cultivation_forest_land_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <div class="row"
             v-if="api_data.Farmer.cultivation_government_graze_land_land_acre || api_data.Farmer.cultivation_government_graze_land_land_guntha || api_data.Farmer.cultivation_government_graze_land_land"
        >
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_government_graze_land_land_acre"
                    v-bind:label="'Acre'"
                ></label-text>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_government_graze_land_land_guntha"
                    v-bind:label="'Guntha'"
                ></label-text>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'cultivation_government_graze_land_land'"
                v-bind:head_title="'Government Graze Forest Land'"
                v-bind:operation_mode="'read'"
                v-bind:form_fields="default_form_fields"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_government_graze_land_details'"
            v-bind:head_title="'Government Graze Land Details'"
            v-bind:default_autocomplete_list="cultivation_forest_land_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <div class="row"
             v-if="api_data.Farmer.cultivation_ayurvedic_land_acre || api_data.Farmer.cultivation_ayurvedic_land_guntha || api_data.Farmer.cultivation_ayurvedic_land"
        >
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_ayurvedic_land_acre"
                    v-bind:label="'Acre'"
                ></label-text>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label-text
                    v-bind:text="api_data.Farmer.cultivation_ayurvedic_land_guntha"
                    v-bind:label="'Guntha'"
                ></label-text>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'cultivation_ayurvedic_land'"
                v-bind:head_title="'Ayurvedic Forest Land'"
                v-bind:operation_mode="'read'"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_ayurvedic_land_details'"
            v-bind:head_title="'Ayurvedic Land Details'"
            v-bind:default_autocomplete_list="cultivation_ayurvedic_land_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_honey'"
            v-bind:head_title="'Honey Farming'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_tendu_leaves'"
            v-bind:head_title="'Tendu Leaves Details'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'cultivation_forest_production'"
            v-bind:head_title="'Forest Production'"
            v-bind:default_autocomplete_list="cultivation_forest_production_default_autocomplete"
            v-bind:default_form_fields_class="default_form_fields_class"
            v-bind:operation_mode="'read'"
            v-bind:form_fields="default_form_fields"
        ></question-with-note-and-multi-input>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'show-cultivation-information',
  props: {
    api_data: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data: () => ({
    land_forest_cultivation_default_autocomplete: [],
    cultivation_ayurvedic_land_default_autocomplete: [
      'તુલસી',
      'મોરેંગા (સારાગુઆ)',
      'હળદર (હળદર)',
      'કોલિયા',
      'અશ્વગંધા',
      'અલસી',
      'કુવરપાટો',
      'બ્રહ્મી',
      'આમળા',
      'અન્ય'
    ],
    cultivation_forest_production_default_autocomplete: [
      'મહોડા ફૂલ',
      'ડોળી',
      'ચારોળી',
      'જંગલ મધ',
      'લાખ',
      'ગુંદર',
      'ચીભડા',
      'ઉબરા',
      'શેર જંગલી કંદમૂળ',
      'સૂર્યો',
      'તા ડ ફળી',
      'તાળી',
      'નીરો',
      'ખાખરા પાન',
      'જંગલી આમળા'
    ],
    cultivation_forest_land_default_autocomplete: [
      'મકાઇ/સફેદ',
      'મકાઇ/પીળો',
      'ડાંગર',
      'ડાંગરકાળી',
      'તુવેર',
      'અડદ',
      'મગ',
      'દેસીચણા',
      'સોયાબીન',
      'મગફળી',
      'તલ',
      'ઘઉં',
      'કોદરા',
      'કારેલા',
      'રીંગણ',
      'ભીંડા',
      'ડુંગરી',
      'ટામેટા',
      'સૂરણ',
      'ગવાર',
      'ચોળી',
      'બટાકા',
      'વાલોડ',
      'ટીડોળા',
      'કારેલા',
      'ફ્લાવર',
      'કોબીજ',
      'દુધી',
    ],
    land_forest_house_default_autocomplete: [
      'કાચું', 'પાકું', 'Raw', 'Complete'
    ],
    land_forest_well_default_autocomplete: [
      'કાચું', 'પાકું', 'Raw', 'Complete'
    ],
    default_form_fields_class: 'col-md-2',
    default_form_fields: {
      'title': {
        'name': 'title',
        'label': 'Particular',
      },
      'production': {
        'name': 'production',
        'type': 'textarea',
        'label': 'Production',
      },
      'fertilizer': {
        'name': 'fertilizer',
        'type': 'textarea',
        'label': 'Fertilizer',
      },
      'quantity_to_sell': {
        'name': 'quantity_to_sell',
        'type': 'textarea',
        'label': 'Quantity to Sell',
      },
      'quantity_to_sell_seed': {
        'name': 'quantity_to_sell_seed',
        'type': 'textarea',
        'label': 'Quantity to Sell Seed',
      },
      'note': {
        'name': 'note',
        'type': 'textarea',
        'label': 'Note',
      }
    },
  })
}
</script>
